import { Home } from '@mui/icons-material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CategoryIcon from '@mui/icons-material/Category';
import InventoryIcon from '@mui/icons-material/Inventory';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import Person4Icon from '@mui/icons-material/Person4';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import EngineeringIcon from '@mui/icons-material/Engineering';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MailOutlineIcon from '@mui/icons-material/MailOutline';


export const side_menus = [
    {
      menuName: 'Dashboard',
      icon: HomeOutlinedIcon,
      route: '/'
    },
    // {
    //   menuName: "Explore Apps",
    //   icon: EngineeringIcon,
    //   route: "/explore",
    // },
    {
      menuName: 'Lead Management',
      icon: PostAddOutlinedIcon,
      route: null,
      submenus: [
          { name: 'All Leads', route: '/leads', icon: InventoryIcon },
          { name: 'Lead Assignment', route: '/leadassigment', icon: ViewCarouselIcon },
          { name: 'Lead Followups', route: '/leadfollowups', icon: ViewCarouselIcon },
          { name: 'Demo schedule', route: '/leadschedule', icon: ViewCarouselIcon },
          { name: 'Lead Analytics', route: '/leadanalytics', icon: ViewCarouselIcon },
          // { name: 'B2B Lead Template', route: '/leadtemplate', icon: InventoryIcon },
          // { name: 'B2B Lead Inactive', route: '/leadinactive', icon: InventoryIcon },
          { name: 'Import & Export Leads', route: '/leadsexport', icon: ViewCarouselIcon }
        ]
    },
    {
      menuName: 'Customer Management',
      icon: SupervisorAccountOutlinedIcon,
      route: null,
      submenus: [
        { name: 'Customer List', route: '/customers', icon: InventoryIcon },
        { name: 'Customer Plan Creation', route: '/customerplans', icon: ViewCarouselIcon },
        { name: 'Inactive Customers', route: '/inactivecustomers', icon: ViewCarouselIcon },
        { name: 'Report Export', route: '/customerreport', icon: ViewCarouselIcon },
        { name: 'Customer Analytics', route: '/customeranalytics', icon: ViewCarouselIcon },
      ]
    },
    {
      menuName: 'Service Management',
      icon: EngineeringIcon,
      route: null,
      submenus: [
        { name: 'Service List', route: '/services', icon: InventoryIcon },
        { name: 'Inactive Service', route: '/inactiveservices', icon: ViewCarouselIcon },
      ]
    },   
    // {
    //   menuName: 'B2B Lead Management',
    //   icon: BusinessCenterIcon,
    //   route: null,
    //   submenus: [
    //     { name: 'B2B Lead Template', route: '/leadtemplate', icon: DescriptionIcon },
    //     { name: 'B2B Lead Inactive', route: '/leadinactive', icon: HighlightOffIcon },
    //   ]
    // }, 
    // {
    //   menuName: 'Quote Management',
    //   icon: EngineeringIcon,
    //   route: null,
    //   submenus: [
    //     { name: 'Quote Template', route: '/quote', icon: InventoryIcon },
    //     { name: 'Inactive Quote Template', route: '/inactivequote', icon: ViewCarouselIcon },
    //   ]
    // },
    {
        menuName: 'Showcase Management',
      icon: AddShoppingCartOutlinedIcon,
        route: null,
        submenus: [
          { name: 'All Templates', route: '/templates', icon: InventoryIcon },
          { name: 'Inactive Templates', route: '/inactivetemplates', icon: ViewCarouselIcon },
        ]
      },
      // {
      //   menuName: 'Chatbot Management',
      //   icon: BuildOutlinedIcon,
      //   route: null,
      //   submenus: [
      //     { name: 'Chatbot', route: '/chatbot', icon: InventoryIcon },
      //     { name: 'Chatbot Analytics', route: '/chatbotanalytics', icon: ViewCarouselIcon },
      //     { name: 'Chatbot Keyword', route: '/chatbotkeyboard', icon: ViewCarouselIcon },
      //   ]
      // },
    {
      menuName: 'Datahub Management',
      icon: DescriptionOutlinedIcon,
      route: null, 
      submenus: [
        { name: 'All', route: '/datahub', icon: InventoryIcon },
        { name: 'Product List', route: '/datahub/product', icon: InventoryIcon },
        { name: 'Product Inactive', route: '/datahub/product?inactive=true', icon: InventoryIcon },
        { name: 'Product Template', route: '/datahub/product/template', icon: InventoryIcon },
        { name: 'Inspiration List', route: '/inspirationlist', icon: ViewCarouselIcon },
        { name: 'Inspiration Inactive', route: 'datahub/inspiration?inactive=true', icon: ViewCarouselIcon },
        { name: 'Inspiration Template', route: 'datahub/inspiration/template', icon: ViewCarouselIcon },
      ]
    },
    {
        menuName: 'Employee Management',
        icon: BadgeOutlinedIcon,
        actions: [
          {name: 'View Employee', value: "employee_get", mname:'Employee List'},
          {name: 'Add Employee', value: "employee_create", mname:'Employee List'},
          {name: 'Add Role', value: "role_create", mname:'Employee Role Setup'},
          {name: 'View Role', value: "role_get", mname:'Employee Role Setup'},
          {name: 'Inactive Employee', value: "employee_inactive", mname:'Inactive Employee'},
        ],
        route: null, 
        submenus: [
          { name: 'Employee List', route: '/employee', icon: InventoryIcon },
          { name: 'Employee Role Setup', route: '/rolesetup', icon: ViewCarouselIcon },
          { name: 'Inactive Employee', route: '/inactiveemployee', icon: ViewCarouselIcon }
        ]
      },

      // {
      //   menuName: 'Email Template',
      // icon: MailOutlineIcon,
      //   route: '/email',
        // submenus: [
        //   { name: 'All Templates', route: '/email', icon: InventoryIcon },
        //   { name: 'Inactive Templates', route: '/inactivetemplates', icon: ViewCarouselIcon },
        // ]
      // },
      {
        menuName: 'Settings',
        icon: SettingsOutlinedIcon,
        route: null, 
        submenus: [
          // { name: 'Add Template ', route: '/addtemplate', icon: InventoryIcon },
          // { name: 'Add Service ', route: '/addservice', icon: InventoryIcon },
          // { name: 'Add Product', route: '/addproduct', icon: ViewCarouselIcon },
          // { name: 'Add Inspiration', route: '/addinspiration', icon: ViewCarouselIcon },
          { name: 'Email Template ', route: '/email', icon: MailOutlineIcon },
          { name: 'SMS Module', route: '/smsmodule', icon: ViewCarouselIcon },
          { name: 'Email Module', route: '/emailmodule', icon: ViewCarouselIcon },
          { name: 'Whatsapp Module', route: '/whatsappmodule', icon: ViewCarouselIcon },
        ]
      },
  ];